/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import AppConfigManagementDash from "../../components/AppConfigManagement";
import Navbar from "../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const AppConfigManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.appConfig?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <AppConfigManagementDash userConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default AppConfigManagement;
